export default __webpack_public_path__ + "static/media/021-djembe.9df68323.svg";